export default class IndexAnchorObserver {
  static anchors = new Map();
  static observer = null;

  static init() {
      if (this.observer) this.dispose();
      
      const elements = document.querySelectorAll('[data-index-anchor]');
      elements.forEach(el => {
          const indexId = el.getAttribute('data-index-anchor');
          const anchorContainer = document.getElementById(indexId);
          if (anchorContainer) {
              this.anchors.set(el, anchorContainer);
          }
      });

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          root: null,
          rootMargin: '0px',
          threshold: 0.5
      });

      this.anchors.forEach((_, element) => this.observer.observe(element));
  }

  static onIntersect(entries) {
      entries.forEach(entry => {
          const target = entry.target;
          const indexId = target.getAttribute('data-index-anchor');
          const anchorContainer = document.getElementById(indexId);
          if (!anchorContainer) return;
          
          if (entry.isIntersecting) {
              anchorContainer.querySelectorAll('.--active').forEach(el => el.classList.remove('--active'));
              const link = anchorContainer.querySelector(`a[href="#${target.id}"]`);
              if (link) link.classList.add('--active');
          }
      });
  }

  static dispose() {
      if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
      }
      this.anchors.clear();
  }
}